export const sectionTitleRowButtonSx = {
  width: 261,
  height: 24,
  minWidth: 0,
  px: '4px',
  pt: 0,
  pb: '4px',
  borderRadius: '6px',
  justifyContent: 'space-between',
  alignItems: 'center',
  bgcolor: 'transparent',
  color: 'inherit',
  '&:hover': { bgcolor: 'transparent' },
}

export const sectionTitleRowTitleSx = {
  fontWeight: 590,
  fontSize: 12,
  lineHeight: '120%',
  color: '#11151a',
}

export const sectionTitleRowActionSx = (actionFilled, onActionClick) => ({
  px: '4px',
  borderRadius: '4px',
  cursor: onActionClick ? 'pointer' : 'default',
  bgcolor: actionFilled ? '#fcfbfa' : 'transparent',
})

export const sectionTitleRowActionLabelSx = {
  fontWeight: 590,
  fontSize: 10,
  lineHeight: '20px',
  color: '#11151a',
}
